// Constants for different requests for current reducer
export default {
  setBranchID: 'SET_BRANCH_ID',
};
